import { useMemo } from 'react';

const CAP_BADGES = [
  { key: 'has_gps', label: 'GPS' },
  { key: 'has_temperature', label: 'TEMP' },
  { key: 'has_humidity', label: 'HUM' },
  { key: 'has_weight', label: 'WEIGHT' },
  { key: 'has_bag_sensor', label: 'BAG' },
];

export function DeviceStep4Review({ formData, tenants }) {
  const assignedTenant = useMemo(() => tenants.find((t) => t.id === formData.tenant_id), [tenants, formData.tenant_id]);
  const activeCaps = useMemo(() => CAP_BADGES.filter((c) => formData[c.key]), [formData]);

  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">
        Review device details before registration:
      </p>

      <div className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-4 space-y-3">
        <Row label="Serial Number" value={formData.serial_number} mono />
        {formData.module_sn && <Row label="Module SN" value={formData.module_sn} mono />}
        <Row label="Model" value={formData.device_model} />
        <div className="flex justify-between py-2 border-b border-slate-200 dark:border-slate-600">
          <span className="text-slate-500 dark:text-slate-400">Capabilities</span>
          <div className="flex gap-2 flex-wrap justify-end">
            {activeCaps.map((c) => (
              <span
                key={c.key}
                className="px-2 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 text-xs rounded"
              >
                {c.label}
              </span>
            ))}
          </div>
        </div>
        {assignedTenant && <Row label="Assigned To" value={assignedTenant.name} />}
        {formData.location && <Row label="Location" value={formData.location} last />}
      </div>
    </div>
  );
}

function Row({ label, value, mono = false, last = false }) {
  return (
    <div className={`flex justify-between py-2 ${last ? '' : 'border-b border-slate-200 dark:border-slate-600'}`}>
      <span className="text-slate-500 dark:text-slate-400">{label}</span>
      <span className={`text-slate-900 dark:text-slate-100 ${mono ? 'font-mono' : ''}`}>{value}</span>
    </div>
  );
}
